import { useLang } from "@/i18n/LanguageContext";
import { waLink } from "@/lib/constants";

export default function WhatsAppFloat() {
  const { t } = useLang();
  return (
    <a
      data-testid="floating-whatsapp"
      href={waLink("Hola Modolo, quiero pedir un presupuesto.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("floating.wa_label")}
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 group"
    >
      <span className="absolute -top-10 right-0 bg-neutral-900 text-white text-xs font-semibold px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-all whitespace-nowrap pointer-events-none">
        {t("floating.wa_label")}
      </span>
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-lg shadow-green-900/30 wa-pulse hover:scale-105 transition-transform">
        <svg width="28" height="28" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.11 17.46c-.29-.15-1.72-.85-1.99-.94-.27-.1-.46-.15-.66.15-.2.29-.76.94-.93 1.13-.17.2-.34.22-.64.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.58-.48-.5-.66-.51-.17-.01-.37-.01-.56-.01s-.51.07-.78.37c-.27.29-1.02 1-1.02 2.44s1.05 2.83 1.19 3.02c.15.2 2.06 3.14 4.99 4.4.7.3 1.24.48 1.66.61.7.22 1.33.19 1.83.12.56-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.2-.55-.34zm-5.28 7.22h-.01a10.7 10.7 0 01-5.45-1.49l-.39-.23-4.05 1.06 1.08-3.95-.25-.41a10.73 10.73 0 01-1.64-5.73c0-5.93 4.83-10.76 10.77-10.76a10.7 10.7 0 017.61 3.15 10.7 10.7 0 013.15 7.61c0 5.93-4.83 10.75-10.82 10.75zm9.15-19.91A12.86 12.86 0 0013.83 1C6.7 1 .89 6.81.89 13.94c0 2.28.6 4.51 1.73 6.46L.79 27l6.77-1.78a12.89 12.89 0 006.26 1.6h.01c7.14 0 12.95-5.81 12.95-12.94 0-3.46-1.35-6.71-3.81-9.11z"/>
        </svg>
      </span>
    </a>
  );
}
